import { render } from "./QuestionWeight.vue?vue&type=template&id=ee971b36&ts=true"
import script from "./QuestionWeight.vue?vue&type=script&lang=ts"
export * from "./QuestionWeight.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__